export default function (itemHeight, { itemPadding = 3 } = {}) {
    return {
        props: {
            scrollerRef: HTMLDivElement,
            virtualScroll: {
                type: Boolean,
                default: true
            }
        },
        data: () => ({
            viewedFirstIndex: 0,
            viewedLastIndex: 0
        }),
        methods: {
            calcViewedFirstIndex() {
                if (!this.virtualScroll) return 0;

                const { scrollTop } = this.scrollerRef;
                const startIndex = Math.floor(scrollTop / itemHeight);

                return Math.max(startIndex - itemPadding, 0);
            },
            calcViewedLastIndex() {
                if (!this.virtualScroll) return this.itemsLength;

                const { clientHeight } = this.scrollerRef;
                const amountSeen = Math.ceil(clientHeight / itemHeight);
                const endIndex = this.viewedFirstIndex + amountSeen;

                return Math.min(endIndex + itemPadding, this.itemsLength);
            },
            onScroll() {
                if (this.scrollerRef) {
                    this.viewedFirstIndex = this.calcViewedFirstIndex();
                    this.viewedLastIndex = this.calcViewedLastIndex();
                }
            }
        },
        computed: {
            virtualScrollMargins() {
                if (!this.virtualScroll) return {};

                return {
                    'margin-top': `${this.viewedFirstIndex * itemHeight}px`,
                    'margin-bottom': `${(this.itemsLength - this.viewedLastIndex) * itemHeight}px`
                };
            }
        },
        beforeDestroy() {
            if (this.scrollerRef) {
                this.scrollerRef.removeEventListener('scroll', this.onScroll);
            }
            window.removeEventListener('resize', this.onScroll);
        },
        mounted() {
            window.addEventListener('resize', this.onScroll);
        },
        watch: {
            scrollerRef: {
                handler(newRef, oldRef) {
                    if (oldRef) {
                        oldRef.removeEventListener('scroll', this.onScroll);
                    }
                    if (newRef) {
                        newRef.addEventListener('scroll', this.onScroll);
                        this.onScroll();
                    }
                },
                immediate: true
            }
        }
    };
}
